import axios from "axios";

export const sendESign = (
  appId: number,
  signatories: any,
  sessionId: string | null
) => {
  return axios
    .post(
      `${process.env.REACT_APP_BASE_URL}send/sign/application`,
      {
        params: {
          //   filter: "[]",
          app_id: appId,
          key_person_id: signatories,
          // signed_application_form_status: "Sent for esign",
        },
      },
      {
        headers: {
          Authorization: `Bearer ${sessionId}`,
        },
      }
    )
    .then((response) => {
      return response;
    })
    .catch((err) => err);
};
